import { APIHandler } from "utilities/apiHandler";

import { TaxGroups } from "../TaxGroupList/TaxGroupList.api.types";
import {
    type TaxGroupCreateRequest,
    TaxGroupCreateResponse,
    TaxGroupDeleteResponse,
    TaxGroupEntity,
    type TaxGroupUpdateRequest,
    TaxGroupUpdateResponse,
} from "./TaxGroup.api.types";

export interface ITaxGroupHandler {
    get(id: number): Promise<TaxGroupEntity>;
    getDefault(): Promise<TaxGroupEntity>;
    create(request: TaxGroupCreateRequest): Promise<TaxGroupCreateResponse>;
    update(id: number, formData: TaxGroupUpdateRequest): Promise<TaxGroupUpdateResponse>;
    delete(ids: number[]): Promise<TaxGroupDeleteResponse>;
    getTaxGroups(
        builderId: number,
        jobId?: number,
        proposalId?: number,
        showImportOption?: boolean,
    ): Promise<TaxGroups>;
}

export class TaxGroupHandler implements ITaxGroupHandler {
    async get(id: number): Promise<TaxGroupEntity> {
        return await APIHandler(`/api/TaxGroups/${id}`, {
            method: "GET",
            responseType: TaxGroupEntity,
        });
    }

    async getDefault(): Promise<TaxGroupEntity> {
        return await APIHandler(`/api/TaxGroups/DefaultInfo`, {
            method: "GET",
            responseType: TaxGroupEntity,
        });
    }

    async create(request: TaxGroupCreateRequest): Promise<TaxGroupCreateResponse> {
        return await APIHandler(`/api/TaxGroups`, {
            method: "POST",
            data: request,
            responseType: TaxGroupCreateResponse,
        });
    }

    async update(id: number, request: TaxGroupUpdateRequest): Promise<TaxGroupUpdateResponse> {
        return await APIHandler(`/api/TaxGroups/${id}`, {
            method: "PUT",
            data: request,
            responseType: TaxGroupUpdateResponse,
        });
    }

    async delete(ids: number[]): Promise<TaxGroupDeleteResponse> {
        return await APIHandler(`/api/TaxGroups`, {
            method: "DELETE",
            data: ids,
            responseType: TaxGroupDeleteResponse,
        });
    }

    async getTaxGroups(
        builderId: number,
        jobId?: number,
        proposalId?: number,
        showImportOption?: boolean,
    ): Promise<TaxGroups> {
        return await APIHandler(`/api/TaxGroups/Dropdown`, {
            method: "GET",
            data: { builderId, jobId, proposalId, showImportOption },
            responseType: TaxGroups,
        });
    }
}
